module.exports = __webpack_public_path__ + "static/media/2020.5.14五月主题党日.9a1071f3.jpg";